import Layout from "../../pages/layout";
import "./style.scss";

const LegalPage = ({ title, updated, children }) => {
  return (
    <Layout>
      <div className="container">
        <div className="legal-page py-36">
          <h1 className="font-28 font-bold mb-8">{title}</h1>
          {updated && (
            <p className="legal-page_updated font-14 mb-24">{updated}</p>
          )}
          {children}
        </div>
      </div>
    </Layout>
  );
};

export default LegalPage;
